import React from 'react';
import { Box } from '@mui/material';

import { ScheduleGrid } from './ScheduleGrid';

export function Schedule() {
  return (
    <Box sx={{ flexGrow: 1, height: 'inherit' }}>
      <ScheduleGrid />
    </Box>
  );
}
